const PAGE_WIDTH = 884.55
const PAGE_HEIGHT = 948.47
const SCALE = 1.5
const GAP = 40
const SVG_STYLE = '.cls-1{fill:#fff}text{font-weight:500;letter-spacing:.05em}'

function collectMyprofileSvgPages(): SVGElement[] {
  const front = document.querySelector('#myprofile-preview-front svg')
  const back = document.querySelector('#myprofile-preview-back svg')
  return [front, back].filter((el): el is SVGElement => !!el)
}

async function inlineSvgImages(svgEl: SVGElement): Promise<void> {
  const images = svgEl.querySelectorAll('image')
  for (const img of Array.from(images)) {
    const href = img.getAttribute('xlink:href') || img.getAttribute('href')
    if (!href || href.startsWith('data:')) continue
    try {
      const res = await fetch(href)
      const blob = await res.blob()
      const dataUrl = await new Promise<string>((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result))
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
      img.setAttribute('xlink:href', dataUrl)
      img.setAttribute('href', dataUrl)
    } catch {
      // 読み込めない画像はスキップして他を描画する
    }
  }
}

function svgToImage(svgEl: SVGElement): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const xml = new XMLSerializer().serializeToString(svgEl)
    const url = URL.createObjectURL(
      new Blob([xml], { type: 'image/svg+xml;charset=utf-8' })
    )
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve(img)
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('画像の生成に失敗しました'))
    }
    img.src = url
  })
}

export async function buildMyprofileImageBlob(): Promise<Blob> {
  const pages = collectMyprofileSvgPages()
  if (!pages.length) throw new Error('プレビューが見つかりませんでした')
  const imgs: HTMLImageElement[] = []
  for (const svg of pages) {
    const clone = svg.cloneNode(true) as SVGElement
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
    clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink')
    clone.setAttribute('width', String(PAGE_WIDTH))
    clone.setAttribute('height', String(PAGE_HEIGHT))
    const styleEl = document.createElement('style')
    styleEl.textContent = SVG_STYLE
    clone.insertBefore(styleEl, clone.firstChild)
    await inlineSvgImages(clone)
    imgs.push(await svgToImage(clone))
  }
  const canvas = document.createElement('canvas')
  canvas.width = Math.round(
    (PAGE_WIDTH * imgs.length + GAP * (imgs.length - 1)) * SCALE
  )
  canvas.height = Math.round(PAGE_HEIGHT * SCALE)
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('画像の生成に失敗しました')
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  imgs.forEach((img, i) => {
    ctx.drawImage(
      img,
      Math.round(i * (PAGE_WIDTH + GAP) * SCALE),
      0,
      Math.round(PAGE_WIDTH * SCALE),
      Math.round(PAGE_HEIGHT * SCALE)
    )
  })
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob)
      } else {
        reject(new Error('画像の生成に失敗しました'))
      }
    }, 'image/png')
  })
}
